import { z } from "zod";

export const RequestStatusSchema = z.enum(["PENDING", "APPROVED", "REJECTED"]);
export const TaskStatusSchema = z.enum(["PENDING", "COMPLETED"]);
export const BlockStatusSchema = z.enum([
  "PENDING",
  "IN_PROGRESS",
  "WAITING_ON_VENDOR",
  "WAITING_ON_REQUESTER",
  "WAITING_ON_EXTERNAL_PARTY",
]);

export type BlockStatus = z.infer<typeof BlockStatusSchema>;
export type TaskStatus = z.infer<typeof TaskStatusSchema>;

export type RequestStatus = z.infer<typeof RequestStatusSchema>;
